var EmployeeSearch = {};

(function ( $ ) {
	var container = $( '.js-employeeContainer' );
	var details = $( '.js-details' );

	if ( $( '.js-employee-item' ).length >= 4 ) {
		container.addClass( 'edge-position' );
	}

	$( '.js-accordion' ).on( 'click', function(){
		details.slideUp();
		$( this ).parent( '.js-employee-item' ).find( '.js-details' ).stop().slideToggle();
	});

	function detailsVisibility() {

		$( '.js-show-details' ).on( 'click', function ( e ) {
			e.stopPropagation();
			keydownClick();
			details.removeClass( 'is-show' );
			$( '.detail-curet' ).removeClass( 'is-show' );
			$( this ).parent( '.js-employee-item' ).find( '.js-details' ).addClass( 'is-show' );
			$( this ).parent( '.js-employee-item' ).find( '.detail-curet' ).addClass( 'is-show' );
			$( this ).css( { 'opacity': '0' } );
			$( '.js-show-details' ).css( { 'opacity': '1' } );
		} );

		details.on( 'click', function ( e ) {
			e.stopPropagation();
			keydownClick();
		} );

		$( 'body' ).on( 'click', function ( e ) {
			keydownClick();
			details.removeClass( 'is-show' );
			$( '.detail-curet' ).removeClass( 'is-show' );
			$( '.js-show-details' ).css( { 'opacity': '1' } );
		} );

	}

	function detailsPosition() {

		details.each( function () {

			if ( $( this ).offset().left <= 0 ) {
				$( this ).addClass( 'touches-left' );
			} else {
				$( this ).removeClass( 'touches-left' );
			}

			if ( $( window ).outerWidth() - ($( this ).offset().left + $( this ).outerWidth()) <= 0 ) {
				$( this ).addClass( 'touches-right' );
			} else {
				$( this ).removeClass( 'touches-right' );
			}

		} );


	}

	EmployeeSearch.init = function () {
		var searchInput = $( '#employeeSearchInput' );
		var employeeItems = container.find( '.js-employee-item' );
		var noMatchText = container.find( '.js-no-match-text' );

		searchInput.keyup( function () {
			var searchText = searchInput.val().toLowerCase();
			var shownCount = 0;

			$.each( employeeItems, function ( index, item ) {
				item = $( item );
				var itemName = item.data( 'name' ).toLowerCase();

				if ( itemName.indexOf( searchText ) === -1 ) {
					item.hide();
				} else {
					item.show();
					shownCount++;
				}
			} );

			if ( shownCount === 0 ) {
				noMatchText.show();
			} else {
				noMatchText.hide();
			}
		} );
	};

	if ( container.length ) {
		$( EmployeeSearch.init );
	}

	detailsVisibility();

	$( window ).on( 'load', function () {
		detailsPosition();
	} );

	$( window ).on( 'resize', function () {
		details.removeClass( 'is-show' );
		$( '.detail-curet' ).removeClass( 'is-show' );
	} );

})( jQuery );
